import React from "react";

const OutreachIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_512)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.03099 1.66667C11.6661 1.66667 15.6477 2.47816 17.5011 4.33908C17.9706 4.81092 18.585 5.73506 18.585 7.0885C18.585 9.49483 16.654 13.1868 14.5218 15.3282C13.4195 16.4351 11.6661 17.8816 9.30743 17.8816C7.00169 17.8816 5.24077 16.3092 4.731 15.7971C2.77812 13.8362 1.37927 10.8598 1.37927 8.08448C1.37927 6.33333 1.8764 4.80172 3.14479 3.52873C4.3195 2.34942 6.34364 1.66667 9.03099 1.66667ZM12.2925 11.2632C13.1821 10.3695 13.4218 9.26896 13.4218 8.66322C13.4218 8.22414 13.3069 7.57988 12.7597 7.03103C11.9206 6.1885 10.9913 5.95057 9.98042 5.95057C8.69996 5.95057 7.83962 6.3569 7.26663 6.93276C6.8172 7.38391 6.4287 8.07759 6.4287 9.06322C6.4287 10.0483 6.95168 11 7.5218 11.5718C8.04824 12.1006 8.87582 12.492 9.70916 12.492C10.5425 12.492 11.4028 12.1569 12.2925 11.2632Z",
  fill: "#5952FF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_512"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.2414,
  height: 16.6667,
  fill: "white",
  transform: "translate(1.37927 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(OutreachIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;